var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#FAF1FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.875 6.62355V12.2485C14.8747 12.3019 14.863 12.3546 14.8407 12.4031C14.8184 12.4516 14.786 12.4948 14.7456 12.5298C14.0294 13.15 13.3445 13.3735 12.6916 13.3735C11.8052 13.3735 10.9773 12.9639 10.2072 12.5837C8.96266 11.9673 7.88078 11.4334 6.625 12.4253V14.4985C6.625 14.598 6.58549 14.6934 6.51516 14.7637C6.44484 14.834 6.34946 14.8735 6.25 14.8735C6.15054 14.8735 6.05516 14.834 5.98484 14.7637C5.91451 14.6934 5.875 14.598 5.875 14.4985V6.62355C5.87536 6.57012 5.88713 6.51739 5.90952 6.46889C5.93192 6.42038 5.96442 6.37722 6.00484 6.34229C7.69234 4.88073 9.20687 5.62933 10.5419 6.2898C11.8281 6.92636 12.9433 7.47667 14.2544 6.34229C14.3086 6.29532 14.3751 6.26487 14.4461 6.25455C14.517 6.24423 14.5895 6.25448 14.6548 6.28409C14.7201 6.31369 14.7756 6.3614 14.8146 6.42157C14.8536 6.48173 14.8746 6.55183 14.875 6.62355Z",
    fill: "#9B40C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.5cae1da64fdf6933b891871e0f4e1650.svg";
export { ForwardRef as ReactComponent };